import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Environment } from 'react-relay';

import { SHOW_SHOP_LOCAL_TOAST } from './shopLocalConstants';
import { NotificationsReducerState } from '../notificationsReducer';

const ShopLocalQueryRenderer = React.lazy(() =>
    import(
        /* webpackChunkName: "ShopLocalQueryRenderer" */
        './components/ShopLocalQueryRenderer'
    )
);

type Props = {
    environment: Environment;
};

type ReduxState = { notificationsReducer: NotificationsReducerState };

export const ShopLocalNotificationLoader: FC<Props> = ({ environment }) => {
    const notifications = useSelector(
        (state: ReduxState) => state.notificationsReducer?.notifications || {}
    );
    if (notifications[SHOW_SHOP_LOCAL_TOAST]) {
        return (
            <React.Suspense fallback="">
                <ShopLocalQueryRenderer environment={environment} />
            </React.Suspense>
        );
    }
    return null;
};
